import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import { mobile_sound_details } from 'data/standard-reportV2_2/mobile-sound'
import { mobile_info_details } from 'data/standard-reportV2_2/mobile-info'
import { mobile_general_details } from 'data/standard-reportV2_2/mobile-general'
export default function SubLabelType2({
	type,
	flags,
	item,
	onFillForm,
	answers,
	onOpenValidationModal,
}) {
	const answer = answers.find(ans => ans.dataSetItemID === item.id)
	const is2G = item.label.includes('2G') ? true : false
	const is5G = item.label.includes('5G')
	const is5GArea = item.label.includes('5G (พื้นที่)')
	const isFiveInput = item.label.includes('-ภาค')
	const excelValueColMS = mobile_sound_details.find(
		({ id }) => id === item.id
	)?.excelValueCol ?? []

	const excelValueColMI = mobile_info_details.find(
		({ id }) => id === item.id
	)?.excelValueCol ?? mobile_general_details.find(
		({ id }) => id === item.id
	)?.excelValueCol ?? []

	// const is2G = item.label.includes('2G') ? true : false
	// console.log("excelValueCol", excelValueCol)

	const columnsMS = [
		{ key: 'F', field: 'dataValueMonth1' },
		{ key: 'G', field: 'dataValueMonth2' },
		{ key: 'H', field: 'dataValueMonth3' },
		{ key: 'I', field: 'dataValueMonthAvg' }
	];

	const columnsMI = [
		{ key: 'D', field: 'dataValueMonth1' },
		{ key: 'E', field: 'dataValueMonth2' },
		{ key: 'F', field: 'dataValueMonth3' },
		{ key: 'G', field: 'dataValueMonthAvg' }
	];

	return (
		<>
			{isFiveInput ? (
				<Grid className="col-span-12 text-center border flex flex-row">
					<Grid className="w-3/12 text-center border flex flex-row">
						<Grid className="border-r w-6/12 p-1 font-bold text-left">
							{item.label}
						</Grid>
						<Input
							className={`border-r border-gray-500 w-6/12 p-1 font-bold text-center bg-yellow_input_bg  pointer-events-none`}
							value={answer?.dataValueExtra}
							onChange={e =>
								onFillForm(type, item.id, 'dataValueExtra', e.target.value)
							}
							type="text"
							readOnly
						/>
					</Grid>
					{/* Months */}

					<Input
						className={`border-r border-gray-500 w-2/12 p-1 font-bold text-center bg-green_input_bg pointer-events-none`}
						value={answer?.dataValueMonth1}
						onChange={e =>
							onFillForm(type, item.id, 'dataValueMonth1', e.target.value)
						}
						type="text"
						readOnly
					/>
					<Input
						className={`border-r border-gray-500 w-2/12 p-1 font-bold text-center bg-green_input_bg pointer-events-none`}
						value={answer?.dataValueMonth2}
						onChange={e =>
							onFillForm(type, item.id, 'dataValueMonth2', e.target.value)
						}
						type="text"
						readOnly
					/>
					<Input
						className="border-r border-gray-500 w-2/12 p-1 font-bold text-center bg-green_input_bg pointer-events-none"
						value={answer?.dataValueMonth3}
						onChange={e =>
							onFillForm(type, item.id, 'dataValueMonth3', e.target.value)
						}
						type="text"
						readOnly
					/>
					<Input
						className="border-r border-gray-500 w-1/12 p-1 font-bold text-center bg-green_input_bg pointer-events-none"
						value={answer?.dataValueMonthAvg}
						onChange={e =>
							onFillForm(type, item.id, 'dataValueMonthAvg', e.target.value)
						}
						type="text"
						readOnly
					/>
					{/* Validation */}
					<Grid className="border-r border-b border-gray-500 w-2/12 p-1 font-bold text-center flex justify-center items-center self-center h-full">
						{(
							(
								((!answer?.dataValueMonth1 || !answer?.dataValueMonth2 || !answer?.dataValueMonth3) && !is5G)
								|| ((!answer?.dataValueMonth1 || !answer?.dataValueMonth2) && is5G)
							)
							&& !answer?.isError) ? null : (answer?.isError === 'y' ? (
								answer?.reason === 'ไม่มีบริการ' ? (
									<Grid className="text-gray-500 font-bold text-center">
										ไม่มีบริการ
									</Grid>
								) : (
									<Button
										variant="contained"
										color="secondary"
										onClick={() =>
											onOpenValidationModal(
												item.id,
												answer.reason,
												answer.solution,
												answer.periodSolution,
												answer?.validateFileUrl
											)
										}>
										ไม่ผ่านเกณฑ์
									</Button>
								)
							) : (
								<Grid className="text-green-500 font-bold text-center ">
									ผ่านเกณฑ์
								</Grid>
							))}
					</Grid>
				</Grid>

			) : (
				excelValueColMS.length > 0 ? (
					<Grid className="col-span-12 text-center border flex flex-row justify-around">
						{/* Label Column */}
						<Grid className="border-r w-3/12 p-1 font-bold text-left">
							{item.label}
						</Grid>

						{/* Data Columns */}
						{columnsMS.map(({ key, field }) => (
							field === 'dataValueMonthAvg' ? (
								excelValueColMS.includes(key) ? (
									<Input
										key={key}
										className="border-r border-gray-500 w-1/12 p-1 font-bold text-center bg-green_input_bg pointer-events-none"
										value={answer?.[field]}
										onChange={e => onFillForm(type, item.id, field, e.target.value)}
										type="text"
										readOnly
									/>
								) : (
									<Input
										key={key}
										className="border-r border-gray-500 w-1/12 p-1 font-bold text-center pointer-events-none"
										value={null}
										disabled
										readOnly
									/>
								)
							) : (
								excelValueColMS.includes(key) ? (
									<Input
										key={key}
										className="border-r border-gray-500 w-2/12 p-1 font-bold text-center bg-green_input_bg pointer-events-none"
										value={answer?.[field]}
										onChange={e => onFillForm(type, item.id, field, e.target.value)}
										type="text"
										readOnly
									/>
								) : (
									<Input
										key={key}
										className="border-r border-gray-500 w-2/12 p-1 font-bold text-center pointer-events-none"
										value={null}
										disabled
										readOnly
									/>
								)
							)
						))}
						{/* Validation */}
						<Grid className="border-r border-b border-gray-500 w-2/12 p-1 font-bold text-center flex justify-center items-center self-center h-full">
							{(
								(
									// ((!answer?.dataValueMonth1 || !answer?.dataValueMonth2 || !answer?.dataValueMonth3) && !is5G)
									// || ((!answer?.dataValueMonth1 || !answer?.dataValueMonth2) && is5G)
									(columnsMI.some(({ field }) => !answer?.[field] && excelValueColMS.includes(field)))
								)
								&& !answer?.isError) ? null : (answer?.isError === 'y' ? (
									answer?.reason === 'ไม่มีบริการ' ? (
										<Grid className="text-gray-500 font-bold text-center">
											ไม่มีบริการ
										</Grid>
									) : (
										<Button
											variant="contained"
											color="secondary"
											onClick={() =>
												onOpenValidationModal(
													item.id,
													answer.reason,
													answer.solution,
													answer.periodSolution,
													answer?.validateFileUrl
												)
											}>
											ไม่ผ่านเกณฑ์
										</Button>
									)
								) : (
									<Grid className="text-green-500 font-bold text-center ">
										{is5GArea ? "ครบถ้วน" : "ผ่านเกณฑ์"}

									</Grid>
								))}
						</Grid>
					</Grid>
				) : (
					excelValueColMI.length > 0 ? (
						<Grid className="col-span-12 text-center border flex flex-row justify-around">
							{/* Label Column */}
							<Grid className="border-r w-3/12 p-1 font-bold text-left">
								{item.label}
							</Grid>

							{/* Data Columns */}
							{columnsMI.map(({ key, field }) => (
								field === 'dataValueMonthAvg' ? (
									excelValueColMI.includes(key) ? (
										<Input
											key={key}
											className="border-r border-gray-500 w-1/12 p-1 font-bold text-center bg-green_input_bg pointer-events-none"
											value={answer?.[field]}
											onChange={e => onFillForm(type, item.id, field, e.target.value)}
											type="text"
											readOnly
										/>
									) : (
										<Input
											key={key}
											className="border-r border-gray-500 w-1/12 p-1 font-bold text-center pointer-events-none"
											value={null}
											disabled
											readOnly
										/>
									)
								) : (
									excelValueColMI.includes(key) ? (
										<Input
											key={key}
											className="border-r border-gray-500 w-2/12 p-1 font-bold text-center bg-green_input_bg pointer-events-none"
											value={answer?.[field]}
											onChange={e => onFillForm(type, item.id, field, e.target.value)}
											type="text"
											readOnly
										/>
									) : (
										<Input
											key={key}
											className="border-r border-gray-500 w-2/12 p-1 font-bold text-center pointer-events-none"
											value={null}
											disabled
											readOnly
										/>
									)
								)
							))}
							{/* Validation */}
							<Grid className="border-r border-b border-gray-500 w-2/12 p-1 font-bold text-center flex justify-center items-center self-center h-full">
								{(
									(
										columnsMI.some(({ field }) => !answer?.[field] && excelValueColMS.includes(field))
									)
									&& !answer?.isError) ? null : (answer?.isError === 'y' ? (
										answer?.reason === 'ไม่มีบริการ' ? (
											<Grid className="text-gray-500 font-bold text-center">
												ไม่มีบริการ
											</Grid>
										) : (
											<Button
												variant="contained"
												color="secondary"
												onClick={() =>
													onOpenValidationModal(
														item.id,
														answer.reason,
														answer.solution,
														answer.periodSolution,
														answer?.validateFileUrl
													)
												}>
												ไม่ผ่านเกณฑ์
											</Button>
										)
									) : (
										<Grid className="text-green-500 font-bold text-center ">
											{is5GArea ? "ครบถ้วน" : "ผ่านเกณฑ์"}

										</Grid>
									))}
							</Grid>
						</Grid>
					) : null
				)
			)}
		</>
	);
}
